import React from 'react'
import { BaseQueryChildrenType } from '@/components/types/BaseQueryChildrenType'
import BaseQuery from '@/components/BaseQuery'
import DatabaseTable from '@/components/pages/DataInfoPage/database/DatabaseTable'
import DatasetTable from '@/components/pages/DataInfoPage/dataset/DatasetTable'
import {useSelector} from 'react-redux'
import {InitialStateType} from '@/store/reducers'
import {DATABASE_LIST_QUERY, DATASET_LIST_QUERY} from '@/graphql/query/queries'

export default function DataInfoPage() {
    const {type} = useSelector((state: InitialStateType) => state.user)

    return (
        <>
            <BaseQuery
                query={DATASET_LIST_QUERY}
                loadingMessage='Loading dataset info'
                notFoundMessage='Dataset info is not available'
            >
                {({ data }: BaseQueryChildrenType) => {
                    return <DatasetTable datasets={data?.datasetList} maxHeight={'35vh'} />
                }}
            </BaseQuery>
            {
                type === 'user' && (
                    <BaseQuery
                        query={DATABASE_LIST_QUERY}
                        loadingMessage='Loading database info'
                        notFoundMessage='Database info is not available'
                    >
                        {({ data }: BaseQueryChildrenType) => {
                            return <DatabaseTable databases={data?.databaseList}/>
                        }}
                    </BaseQuery>
                )
            }
        </>
    )
}
